let APIRoot;

const appEnv = process.env.NEXT_PUBLIC_NODE_ENV;

// Allow override via NEXT_PUBLIC_API_URL for ngrok or custom setups
if (process.env.NEXT_PUBLIC_API_URL) {
  APIRoot = process.env.NEXT_PUBLIC_API_URL;
} else if (appEnv === 'staging') {
  APIRoot = 'https://api.lingualbox.jp/';
} else if (appEnv === 'prod') {
  APIRoot = 'https://api.lingualbox.com/';
} else {
  APIRoot = 'http://api.lingualbox.loc:3000/';
  // APIRoot = 'https://api-dev.lingualbox.com/';
}

const ApiConstants = {
  Base: APIRoot,
  LoginWithEmail: APIRoot + 'users/authenticate',
  SignupWithEmail: APIRoot + 'users/create/email',
  Logout: APIRoot + 'auth/sign_out',
  // New token management endpoints
  RefreshToken: APIRoot + 'auth/refresh',
  LogoutWithToken: APIRoot + 'auth/logout',
  LogoutAll: APIRoot + 'auth/logout_all',
  SendResetPasswordLink: APIRoot + 'users/send-reset-password-link',
  ChangePassword: APIRoot + 'users/change-password',
  ResetPassword: APIRoot + 'users/reset-password',
  UpdateStudentProfile: APIRoot + 'users/update-student-profile',
  UpdateIp: APIRoot + 'users/update-ip',
  FetchProfilePhoto: APIRoot + 'users/fetch-profile-photo',
  UploadProfilePhoto: APIRoot + 'users/photo/upload',
  DeleteProfilePhoto: APIRoot + 'users/photo/delete',
  FetchTutors: APIRoot + 'tutors/search',
  FetchUser: APIRoot + 'users/',
  Me: APIRoot + 'me/',
  FetchTimezones: APIRoot + 'fetch-time-zones',
  FetchLevels: APIRoot + 'fetch-levels',
  FetchLanguages: APIRoot + 'fetch-languages',
  FetchLocales: APIRoot + 'fetch-locales',
  FetchMessages: APIRoot + 'fetch-messages',
  FetchSchedules: APIRoot + 'fetch-schedules',
  book: APIRoot + 'book',
  cancelBooking: APIRoot + 'cancel-booking',
  cancelBookingByTutor: APIRoot + 'bookings/cancel/by-tutor',
  FetchTutorBookings: APIRoot + 'fetch-tutor-bookings',
  FetchStudentBookings: APIRoot + 'fetch-student-bookings',
  FetchBookings: APIRoot + 'fetch-bookings',
  FetchBooking: APIRoot + 'fetch-booking',
  FetchHolidays: APIRoot + 'fetch-holidays',
  FetchSlotStatus: APIRoot + 'fetch-slot-status',
  FetchStudentLessons: APIRoot + 'fetch-student-lessons',
  FetchTutorLessons: APIRoot + 'fetch-tutor-lessons',
  FetchTutorLessonsWithOpenIssue: APIRoot + 'tutor-lessons/with-open-issue',
  FetchStudentLessonsWithOpenIssue: APIRoot + 'student-lessons/with-open-issue',
  FetchLessonById: APIRoot + 'fetch-lesson',
  FetchActivePlans: APIRoot + 'fetch-active-plans',
  FetchActivePayment: APIRoot + 'fetch-active-payment',
  FetchCurrentPlan: APIRoot + 'fetch-current-plan',
  FetchLessonSize: APIRoot + 'lesson-size',
  MarkAsSkipped: APIRoot + 'lessons/mark-skipped',
  MarkAsSkippedByTutor: APIRoot + 'lessons/mark-skipped-by-tutor',
  SaveReview: APIRoot + 'lessons/save-review',
  FetchLessonReviewsByTutor: APIRoot + 'lesson-reviews/tutor',
  FetchPronunciationStatuses: APIRoot + 'fetch-pronunciation-statuses',
  CreateSpeakingPracticeSubmission:
    APIRoot + 'pronunciation/practice-submissions',
  FetchSpeakingPracticeSubmission:
    APIRoot + 'pronunciation/practice-submissions/',
  FetchPlacement: APIRoot + 'fetch-placement',
  FetchCourses: APIRoot + 'fetch-courses',
  SetupAgreement: APIRoot + 'paypal/setup-agreement',
  ProcessSubscription: APIRoot + 'plan/subscribe',
  SuspendSubscription: APIRoot + 'plan/suspend',
  CancelSubscription: APIRoot + 'plan/cancel',
  ReactivateSubscription: APIRoot + 'plan/reactivate',
  SetSkypeId: APIRoot + 'users/set-skype-id',
  SetTeamsContactEmail: APIRoot + 'users/set-teams-contact-email',
  FetchSummary: APIRoot + 'summaries',
  SetPlacement: APIRoot + 'set-placement',
  UpdatePlacement: APIRoot + 'update-placement',
  FetchSummaryByLessonId: APIRoot + 'fetch-summary/lesson',
  CreateSummary: APIRoot + 'summary/create',
  UpdateSummary: APIRoot + 'summary/update',
  UpdatePronunciationStatuses: APIRoot + 'pronunciation-statuses/update',
  gcalConnected: APIRoot + 'gcal/connected',
  gcalDisconnected: APIRoot + 'gcal/disconnected',
  fetchConversations: `${APIRoot}conversations`,
  fetchMessages: `${APIRoot}conversations/`,
  sendMessage: `${APIRoot}conversations/`,
  CreateLessonIssue: `${APIRoot}lessons/`,
  FetchLessonIssue: `${APIRoot}lessons/`,
  ResolveLessonIssue: `${APIRoot}lessons/`,
  FetchLecture: `${APIRoot}lectures/`,
};

export const baseUrl = APIRoot;

export default ApiConstants;
